<ng-template #modal>
  <div class="popup-window mx-5 my-5">
    @if (interviewState() && interviewState()?.currentQuestion && !loading) {
      <h1 id="topicTitle" tabindex="-1">{{ messages.getText("WILL.topic." + interviewState()?.navigator?.currentTopic) }}</h1>
      @if (interviewState()?.currentQuestion!.type === 'GROUP') {
        <group-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"
        />

      } @else if (interviewState()!.currentQuestion!.type!.endsWith("TEXT") || interviewState()!.currentQuestion!.type === "DATE" || (interviewState()?.currentQuestion?.type?.endsWith('VIDEO') && !interviewState()?.metadata?.recordingConsented)) {
        <text-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"></text-control>

      } @else if (interviewState()!.currentQuestion!.type === "NOTE" || interviewState()!.currentQuestion!.type === "CONFIRM_OPTION") {
        <confirm-option-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type === "RADIO") {
        <radio-button-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type === "CHECKBOX") {
        <checkbox-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type === "CHARITY") {
        <charity-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>
<!-- FixMe :: This is needed to load the correct charity data -->
<!--          [navigator]="nav"-->

      } @else if (interviewState()!.currentQuestion!.type === "CHARITY_SEARCH") {
        <charity-search-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type?.endsWith('VIDEO')) {
        <video-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type === "DROPDOWN") {
        <dropdown-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type?.endsWith('CURRENCY')) {
        <currency-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type === "EMAIL") {
        <email-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type?.endsWith('NUMBER')) {
        <number-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type?.endsWith('PERCENTAGE')) {
        <percentage-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      } @else if (interviewState()!.currentQuestion!.type === "POSTCODE") {
        <postcode-control
          #questionControl
          [baseForm]="this"
          [form]="this.form"
          [id]="interviewState()!.currentQuestion!.id + '-wrapper'"
          [questionId]="interviewState()!.currentQuestion!.id!"
          [question]="interviewState()!.currentQuestion!"
          [editingResponse]="true"
          [onEnter]="triggerEdit()"/>

      }
    } @else {
      <div class="d-flex" style="height: 50vh !important;">
        <div class="loading text-center mx-auto my-auto">
          <div class="spinner-border text-primary" role="status"></div>
          <h3 style="font-weight:500">Saving, please wait...</h3>
        </div>
      </div>
    }

  </div>
</ng-template>
